import { render, staticRenderFns } from "./QIPFPerf.vue?vue&type=template&id=05b10466"
import script from "./QIPFPerf.vue?vue&type=script&lang=js"
export * from "./QIPFPerf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports